import { appHasDarkTheme } from '@va/util/helpers';
import { isArray } from 'lodash';
import { StackedBarChartDataset, StackedBarChartTooltip } from './StackedBarChartTooltip';

export const externalStackedBarTooltip = (context: any, title?: string) => {
  const { tooltip, chart } = context;
  const isDarkThemeApplied = appHasDarkTheme();

  const { offsetLeft, offsetTop } = chart.canvas;

  const left = offsetLeft + tooltip.caretX;
  const top = offsetTop + tooltip.caretY;

  const getCurrentDatasets: () => StackedBarChartDataset[] = () => {
    if (!tooltip) {
      return [];
    }
    const datasets: StackedBarChartDataset[] =
      tooltip.dataPoints &&
      tooltip.dataPoints.map((dataPoint: any) => {
        const dataIndex = dataPoint.dataIndex;
        const backgroundColor = dataPoint.dataset.backgroundColor;
        const currentValue: number = dataPoint.raw;
        const label: string = dataPoint.dataset.label;
        const color: string = isArray(backgroundColor) ? backgroundColor[dataIndex] : backgroundColor;

        return {
          label,
          color,
          values: [
            {
              colorClass: isDarkThemeApplied ? 'text-gray-charcoal' : 'text-white',
              value: String(currentValue),
            },
          ],
        };
      });
    return datasets;
  };

  return (
    <StackedBarChartTooltip
      isVisible={!!tooltip.opacity}
      title={title}
      currentDatasets={getCurrentDatasets()}
      currentPeriod={tooltip.title[0]}
      coordinates={{ left, top }}
    />
  );
};
